module.exports = __webpack_public_path__ + "img/bahamas.0b8ed5f.webp";